module.exports = __webpack_public_path__ + "static/media/OC3.361a072f.png";